import { render, staticRenderFns } from "./certiticateProHireXpForm.vue?vue&type=template&id=616f62fa&"
import script from "./certiticateProHireXpForm.vue?vue&type=script&lang=js&"
export * from "./certiticateProHireXpForm.vue?vue&type=script&lang=js&"
import style0 from "./certiticateProHireXpForm.vue?vue&type=style&index=0&lang=less&"
import style1 from "./certiticateProHireXpForm.vue?vue&type=style&index=1&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports